module.exports = __webpack_public_path__ + "static/media/CoatingIcon.c2523e2a.png";